import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import LocaleKeys from '../../../../../locales/keys';
import ButtonAction from '../../../../../common/buttonAction';

const useStyles = makeStyles((theme) => ({
  button: {
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: '5px',
    padding: '10px 15px',
    height: '37px',
    width: '100%',
  },
  cancelButton: {
    color: theme.palette.custom.lightBlack,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.custom.white,
    },
  },
  saveButton: {
    '&:hover': {
      backgroundColor: theme.palette.custom.white,
      color: theme.palette.custom.lightBlack,
    },
  },
  removeDevice: {
    borderRadius: 'unset',
    padding: 'unset',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: 'unset',
      color: theme.palette.custom.darkBlue,
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: '16px',
    },
  },
  removeDeviceGrid: {
    alignSelf: 'center',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'left',
    },
  },
  removeDeviceText: {
    fontWeight: '600',
    textTransform: 'capitalize',
    flexWrap: 'no-wrap',
  },
}));

const SaveDevice = ({ formik, removeDeviceContainerHandler }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Grid container>
      <Grid item container xs={12} wrap="wrap" justifyContent="space-between">
        <Grid item xs={5} md={4}>
          <ButtonAction
            size="small"
            buttonClasses={`${classes.button} ${classes.cancelButton}`}
            handler={formik.handleReset}
            label={t(LocaleKeys.subscriptionInfo.devices.cancel)}
          />
        </Grid>
        <Grid item xs={5} md={4}>
          <ButtonAction
            size="small"
            buttonClasses={`${classes.button} ${classes.saveButton}`}
            variant="contained"
            color="primary"
            handler={formik.handleSubmit}
            label={t(LocaleKeys.subscriptionInfo.devices.save)}
          />
        </Grid>
        <Grid item xs={12} md={3} className={classes.removeDeviceGrid}>
          <ButtonAction
            size="small"
            buttonClasses={classes.removeDevice}
            typographyClasses={classes.removeDeviceText}
            variant="text"
            handler={removeDeviceContainerHandler}
            label={t(LocaleKeys.subscriptionInfo.devices.deviceRemove)}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

SaveDevice.propTypes = {
  formik: PropTypes.object.isRequired,
  removeDeviceContainerHandler: PropTypes.func.isRequired,
};

export default SaveDevice;
